import {ProductReviewRatingModel} from 'app/model/products/product-review-rating.model';
export class ProductReviewModel {
    totalNumberOfSubmit: number;
    totalScore: String;
    totalTitle: String;
    ratings: ProductReviewRatingModel[];
    uncommonThings: ProductReviewRatingModel[];
    mysteriousThings: ProductReviewRatingModel;
    pest: ProductReviewRatingModel;

    constructor(totalScore?: String, totalTitle?: String, totalNumberOfSubmit?: number, ratings: ProductReviewRatingModel[] = [], uncommonThings: ProductReviewRatingModel[] = [],
      mysteriousThings?: ProductReviewRatingModel, pest?: ProductReviewRatingModel) {
        this.totalNumberOfSubmit = totalNumberOfSubmit;
        this.totalScore = totalScore;
        this.totalTitle = totalTitle;
        this.ratings = ratings;
        this.uncommonThings = uncommonThings;
        this.mysteriousThings = mysteriousThings;
        this.pest = pest;
    }
  }



// WEBPACK FOOTER //
// ./src/app/model/products/product-review.model.ts